module.exports = __webpack_public_path__ + "static/media/money-bill-wave.68b8c18d.svg";